import { request } from '@/shared/api/request'

export const getDataByBin = (bin) =>
	request({ url: `/contract/branchTransfer/requestBranchData?bin=${bin}`, method: 'GET' })
